<div class="container" *ngIf="loaded">
  <mat-card>
    <h2 translate>request.trace.title</h2>
    <span>{{ 'request.trace.subtitle' | translate }}</span>
  </mat-card>
  <mat-card class="traces" *ngFor="let trace of dataTraces">
    <div class="date">
      <span class="marginRight">{{ trace.date }}</span>
    </div>
    <div class="description">
      <span class="marginRight">{{ trace.description }}</span>
    </div>
    <div class="user">
      <span>{{ trace.user }}</span>
    </div>
  </mat-card>
</div>
